module.exports = __webpack_public_path__ + "static/media/vbn-picture-1.e3871d48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/vbn-picture-1.jpg
// module id = 60
// module chunks = 0